import {
  ACTIVATE_DEPARTMENT,
  BASE_URL,
  CREATE_DEPARTMENT,
  DEACTIVATE_DEPARTMENT,
  DELETE_DEPARTMENT,
  DEPARTMENTS,
  UPDATE_DEPARTMENT,
} from "../config";
import { getSessionId } from "../utils/SessionHandler";
import { handleResponse } from "./responseHandler";

const requestOptions = (method, body) => ({
  method,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getSessionId()}`,
  },
  ...(body ? { body: JSON.stringify(body) } : {}),
});

export async function fetchDepartments() {
  const response = await fetch(BASE_URL + DEPARTMENTS, requestOptions("GET"));
  return handleResponse(response);
}

export async function createDepartment(departmentData) {
  const response = await fetch(
    BASE_URL + CREATE_DEPARTMENT,
    requestOptions("POST", departmentData)
  );
  return handleResponse(response);
}

export async function updateDepartment(departmentData, id) {
  const response = await fetch(
    `${BASE_URL}${UPDATE_DEPARTMENT}/${id}`,
    requestOptions("POST", departmentData)
  );
  return handleResponse(response);
}

async function updateDepartmentStatus(endpoint, id) {
  const response = await fetch(
    `${BASE_URL}${endpoint}/${id}`,
    requestOptions("POST")
  );
  return handleResponse(response);
}

export const activateDepartment = (id) =>
  updateDepartmentStatus(ACTIVATE_DEPARTMENT, id);

export const deactivateDepartment = (id) =>
  updateDepartmentStatus(DEACTIVATE_DEPARTMENT, id);

export const deleteDepartment = (id) =>
  updateDepartmentStatus(DELETE_DEPARTMENT, id);